import { SpinnerIcon } from '@components/utils/icons/SpinnerIcon';
import { TickIcon } from '@components/utils/icons/TickIcon';
import styled from '@emotion/styled';
import { FC } from 'react';

import { useFlowPage } from '../contexts/FlowPageContext';
import { isSuccessFlowPage } from '../utils/validators';

const ICON_SIZE = 10;

const LoaderContainer = styled.div`
    height: ${ICON_SIZE}vh;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const IconContainer = styled.div`
    height: ${ICON_SIZE}vh;
    width: ${ICON_SIZE}vh;
    display: flex;
    justify-content: center;
`;

const SpinnerContainer = styled(IconContainer)`
    padding: ${({ theme }) => theme.spacing.xs};
`;

export const FlowPageLoader: FC = () => {
    const { flowPage, process } = useFlowPage();

    return (
        <LoaderContainer>
            {process?.isLoading ? (
                <SpinnerContainer>
                    <SpinnerIcon />
                </SpinnerContainer>
            ) : (
                <>
                    {isSuccessFlowPage(flowPage) && (
                        <IconContainer>
                            <TickIcon />
                        </IconContainer>
                    )}
                </>
            )}
        </LoaderContainer>
    );
};
